import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { NgxSpinnerService } from "ngx-spinner"; 
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, AbstractControl, ValidationErrors, FormGroupDirective } from '@angular/forms';
import { HelperService } from '../helper.service';
import {Router} from "@angular/router";
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({
providedIn: 'root'
})


@Component({
  selector: 'app-create-admin',
  templateUrl: './create-admin.component.html',
  styleUrls: ['./create-admin.component.css']
})
export class CreateAdminComponent implements OnInit {

  selectadminHide = false;
  PurchasedProducts = [];
  AdminData = [];
  Companies = [];
  countries = [];
  States = [];
  storehide = [];
  adminhide = [];
  timezones = [];
  Storemessage = [];
  Companymessage = [];
  Adminmessage = [];
  selectedCompanies = [];
  Stores = [];
  selectedCompaniesAndstores = [];
  selectedStores = [];
  store_added : string = '';
  Storeimage : string = '';
  primary_color : string = '';
  storeSubmitted = false;
  SubscriptionForm: FormGroup;
  subscriptionData: FormArray;
  successMessage = HelperService.successMessage;
  emptyCompany = true;
  companyId : string = '';
  adminSubmitted = false;
  adminmessage='';
  emailerror='';
  userexist:boolean = true;
  selectedAdmins = [];
  licenseCount = null;
  constructor(private fb: FormBuilder, private userService: UserService, private SpinnerService: NgxSpinnerService, private router: Router ) {
   }

  ngOnInit(): void {
    this.SpinnerService.show(); 
    this.userService.UserPurchasedProducts().subscribe((res) => {
      this.userService.getAdminUsers().subscribe((res) => {
        this.AdminData = res.admin_users;
      });
      this.SpinnerService.hide(); 

    })
  }



  admin_fg = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),

  });

  get admin_fg_control(){
    return this.admin_fg.controls;
  }
  admin_submit(event){
    this.SpinnerService.show();
    this.adminSubmitted = true;
    if(this.admin_fg.invalid){
      this.SpinnerService.hide();
      return;
    }
    console.log(this.admin_fg.value);
    this.userService.createAdminUser(this.admin_fg.value).subscribe((res) => {
      this.SpinnerService.hide();
      if (res.status == 1) {
        this.ngOnInit();
        
        this.adminmessage = 'Your Admin  is Created!';
        setTimeout(() => {
          
          const close_a_admin = document.querySelector('.close_a_admin');
          if (close_a_admin instanceof HTMLElement) {
            close_a_admin.click();
          }
          this.adminModalClose();
        }, 1500);
      }
      else{
        this.emailerror = res.validationErrors.email
      }
    })
  }
  addAdmin(){
    this.formReset();
  }
  enterEmail(event){
    this.emailerror = '';
  }
  adminModalClose(){
    
    // save current route first
    const currentRoute = this.router.url;
    if(this.adminmessage){
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentRoute]); // navigate to same route
      });
    }
    this.formReset();
  }

  formReset(){
    this.emailerror = '';
    this.adminSubmitted = false;
    this.admin_fg.reset;
    this.admin_fg.get('firstname').setValue("");
    this.admin_fg.get('lastname').setValue("");
    this.admin_fg.get('email').setValue("");
    this.selectadminHide = true;
    this.adminmessage = '';
  }
}
